const { volumeFromHeightMap, countHeightMapValues, resolutionOf, averageHeight } = require('./height-map-helpers');

const DEPTH_WHERE_CAMERA_STARTS_GETTING_UNRELIABLE = 0.50; /* m */
const MINIMUM_FRACTION_VISIBLE_FOR_GOOD_VOLUME_DETECTION = 0.06;
class FeedHeightMap {
  #binGeometry;

  /**
   * @param {HeightMapData} heightMap
   * @param {HeightMapData} unextrapolatedHeightMap
   * @param {BinGeometry} binGeometry
   */
  constructor(heightMap, unextrapolatedHeightMap, binGeometry) {
    this.heightMap = heightMap;
    this.unextrapolatedHeightMap = unextrapolatedHeightMap;
    this.#binGeometry = binGeometry;
  }

  /**
   * @returns {number} m^3
   */
  get volumeEstimate() {
    return volumeFromHeightMap(this.heightMap, this.#binGeometry);
  }

  /**
   * @returns {Number}
   */
  get fractionVisible() {
    return countHeightMapValues(this.unextrapolatedHeightMap) / countHeightMapValues(this.heightMap);
  }

  get isIndeterminablyFull() {
    if (countHeightMapValues(this.unextrapolatedHeightMap) === 0) {
      return true;
    }
    const feedIsRoughlyAtTopOfBin = averageHeight(this.unextrapolatedHeightMap) > this.#binGeometry.totalHeight * 0.5;
    return this.fractionVisible < MINIMUM_FRACTION_VISIBLE_FOR_GOOD_VOLUME_DETECTION && feedIsRoughlyAtTopOfBin;
  }

  /**
   * @returns {[Number,Number]}  the minimum and maximum likely bin volumes, in m^3
   */
  get volumeRange() {
    // TODO: Only do this require here to avoid a circular dependency between this file and feed-surface-analysis.js
    const { createHeightMapFromSingleDepth } = require('./feed-surface-analysis');

    if (this.isIndeterminablyFull) {
      const { pan, tilt } = this.#binGeometry.estimatedCameraAngleForBin();
      const maxVolume = this.#binGeometry.totalVolume;
      const minVolume = volumeFromHeightMap(
        createHeightMapFromSingleDepth({
          binGeometry: this.#binGeometry,
          centralDepth: DEPTH_WHERE_CAMERA_STARTS_GETTING_UNRELIABLE /* m */,
          resolution: resolutionOf(this.heightMap),
          pan,
          tilt,
        }),
        this.#binGeometry,
      );
      return [minVolume, maxVolume];
    }

    // TODO/Future: Calculate a range based on this.fractionOfFeedSurfaceVisible
    return [this.volumeEstimate, this.volumeEstimate];
  }
}

exports.FeedHeightMap = FeedHeightMap;
